import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Livecoding #22: A door-answering Slackbot",
  "description": "",
  "published": "2016-09-19T00:00:00.000Z",
  "redirect_from": ["/blog/livecoding-22-a-door-answering-slackbot/swizec/7038"],
  "categories": "Livecoding, Startups, Technical",
  "hero": "./img/E5JakQs.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`This is a Livecoding Recap – an almost-weekly post about interesting things discovered while livecoding ?. Always under 500 words and with pictures. You can follow my channel, `}<a parentName="em" {...{
          "href": "https://livecoding.tv/swizec"
        }}>{`here`}</a>{`. New streams almost `}<strong parentName="em">{`every Sunday at 2pm PDT`}</strong>{`. There’s live chat, come say hai ?`}</em></p>
    <p>{`Aaaaaalmost hacked together a Slack bot that can answer the door. There’s one last step to figure out and then we are ready to rock. ??`}</p>
    <p>{`Buildings in the US, or at least in San Francisco, have buzzers that connect to a phone rather than a purpose-built wall-mounted device. You set it up with your phone, and whenever someone wants to come visit, your phone rings, you say Hello, and buzz them in.`}</p>
    <p>{`It’s perfect for the home. It’s `}<em parentName="p">{`really`}</em>{` annoying for anyone stuck with buzzer duty at the office.`}</p>
    <p>{`A Slack bot can do that for us. Here’s the idea:`}</p>
    <ul>
      <li parentName="ul">{`give the buzzer a Twilio phone number`}</li>
      <li parentName="ul">{`build a small node.js server to answer the phone`}</li>
      <li parentName="ul">{`send Slack message with an `}<em parentName="li">{`“I am so and so”`}</em>{` audio clip`}</li>
      <li parentName="ul">{`offer `}<inlineCode parentName="li">{`Deny`}</inlineCode>{` and `}<inlineCode parentName="li">{`Let them in`}</inlineCode>{` buttons`}</li>
      <li parentName="ul">{`anyone can buzz anyone in`}</li>
      <li parentName="ul">{`profit.`}</li>
    </ul>
    <p>{`The profit part comes if Slack lets me release this as a, say, $10/month service. We’ll see. ?`}</p>
    <p>{`You can also play with it as an `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/door-answer-slackbot"
      }}>{`open source project on Github`}</a>{`. But it’s not really ready for prime-time yet. The code is a mess, and there’s no README file to tell you how to set it up.`}</p>
    <p>{`The bright side is that you can see all my API keys in the livecoding video. I’m going to change those. Probably.`}</p>
    <p>{`When Twilio receives a phone call, it posts to our webhook on `}<inlineCode parentName="p">{`<server>/call`}</inlineCode>{`. This is the start of our user experience. We reply with `}<inlineCode parentName="p">{`Hello! State your name, then press anything`}</inlineCode>{`. Like this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`router.post("/call", function (req, res, next) {
  const caller = req.body.Caller;
  const callSid = req.body.CallSid;

  let twiml = new twilio.TwimlResponse();

  twiml.say("Hello! State your name, then press any key.", { voice: "alice" });

  twiml.record({
    action: \`/call/recording/\${callSid}\`,
    //transcribe: true,
    //transcribeCallback: \`/call/recording/\${callSid}\`,
    maxLength: 60,
  });

  res.type("text/xml");
  res.send(twiml.toString());
});
`}</code></pre>
    <p>{`That `}<inlineCode parentName="p">{`twiml`}</inlineCode>{` stuff constructs a response using TwiML, a Twilio-extended XML language. Twilio can turn `}<inlineCode parentName="p">{`<Say>text</Say>`}</inlineCode>{` commands into spoken dialogue using various voice synthesizers. You’ve gotta use proper punctuation though. It sounds weird otherwise.`}</p>
    <p>{`We ask Twilio to record a response and send the audio clip to our `}<inlineCode parentName="p">{`/call/recording/<id>`}</inlineCode>{` API. In that API, we send a Slack text and put the caller on hold.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`router.post("/call/recording/:callSid", (req, res, next) => {
  const callSid = req.params.callSid;
  const twiml = new twilio.TwimlResponse();
  const recordingUrl = req.body.RecordingUrl;

  let data = {
    attachments: [
      {
        fallback: "Somebody is at the door",
        title: "Somebody is at the door",
        title_link: recordingUrl,
        text: "Click link to hear the recording",
        callback_id: \`door_open:\${callSid}\`,
        actions: [
          {
            name: "open_door",
            text: "Let them in",
            type: "button",
            value: "open_door",
          },
          {
            name: "deny_access",
            text: "No.",
            type: "button",
            value: "deny_access",
          },
        ],
      },
    ],
  };

  webSlack.chat.postMessage("#bot-testing", "", data, () => {
    twiml.say("Thank you. Please hold.", { voice: "alice" });
    twiml.pause(240);

    res.type("text/xml");
    res.send(twiml.toString());
  });
});
`}</code></pre>
    <p>{`We get the audio clip as a URL, and we post to Slack using their Web client thingy. The real-time-messaging client can’t do complex messages.`}</p>
    <p>{`This is what you get on Slack:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "536px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/cb149c4d4f189814418f2df0389a771f/2d920/E5JakQs.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "24.663677130044842%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'99\\'%20viewBox=\\'0%200%20400%2099\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M21%2010l1%202c2%204%201%205-2%205s-4%201-4%205%200%205%202%206c3%200%203%202%200%202-5%200-7%201-6%203%202%201%2023%202%2024%200%200-2-2-3-5-3l-3-1c-1-1%200-1%201-1%202%200%202%200%202-5s-1-6-3-6c-4-1-4-3-2-5l1-2h-6\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/cb149c4d4f189814418f2df0389a771f/ca0a1/E5JakQs.webp 223w", "/static/cb149c4d4f189814418f2df0389a771f/75680/E5JakQs.webp 445w", "/static/cb149c4d4f189814418f2df0389a771f/c5a1c/E5JakQs.webp 536w"],
              "sizes": "(max-width: 536px) 100vw, 536px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/cb149c4d4f189814418f2df0389a771f/e92b6/E5JakQs.png 223w", "/static/cb149c4d4f189814418f2df0389a771f/e66bf/E5JakQs.png 445w", "/static/cb149c4d4f189814418f2df0389a771f/2d920/E5JakQs.png 536w"],
              "sizes": "(max-width: 536px) 100vw, 536px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/cb149c4d4f189814418f2df0389a771f/2d920/E5JakQs.png",
              "alt": "E5JakQs",
              "title": "E5JakQs",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Now comes the part I haven’t figured out yet:`}</p>
    <ol>
      <li parentName="ol">{`Build the API for those Slack buttons – it always throws an error ?`}</li>
      <li parentName="ol">{`Figure out how to continue sending to a Twilio call outside of the original webhoook, if I know the original call ID.`}</li>
    </ol>
    <p>{`The first bit is just a matter of figuring out my config. Slack gives clear instructions for doing that; I just gave up too soon.`}</p>
    <p>{`The second bit, though… that’s hard. I can’t find any documentation for it, and I haven’t had any luck Googling for it either.`}</p>
    <p>{`Gonna talk to Twilio’s help team and finish this up next Sunday. Don’t forget to come watch.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      